import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { validateCard } from '../cardUtils';

var validateCardNumber = function validateCardNumber(number, cardType) {
  var _validation$card, _validation$card$leng, _validation$card2;

  var allowedCardTypes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var luhnValidateJaws = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var isPresent = Boolean(number.length);
  var validation = validateCard(number, cardType, luhnValidateJaws);
  var isAllowed = allowedCardTypes.includes(validation === null || validation === void 0 ? void 0 : (_validation$card = validation.card) === null || _validation$card === void 0 ? void 0 : _validation$card.type);
  var lengths = (_validation$card$leng = validation === null || validation === void 0 ? void 0 : (_validation$card2 = validation.card) === null || _validation$card2 === void 0 ? void 0 : _validation$card2.lengths) !== null && _validation$card$leng !== void 0 ? _validation$card$leng : [];

  var result = _objectSpread(_objectSpread({
    invalid: !(isAllowed && validation.isPotentiallyValid && validation.isValid),
    invalidType: !isAllowed
  }, lengths.length && {
    tooLong: Math.max(...lengths) < number.length,
    tooShort: Math.min(...lengths) > number.length
  }), {}, {
    valueMissing: !isPresent
  });

  result.errors = Object.keys(result).filter(key => result[key]);
  result.isValid = !result.errors.length;
  return result;
};

export { validateCardNumber };